import React, { useState } from "react";
import { TextField } from "@mui/material";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { IsAlert } from "../component/atoms/IsAlert";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { fetchApi } from "../helper/api";
const Daftar = () => {
  const navigate = useNavigate();
  const validationSchema = Yup.object().shape({
    email: Yup.string()
      .required("Email harus diisi")
      .email("Harus format email"),
  });
  const formOptions = { resolver: yupResolver(validationSchema) };
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm(formOptions);
  const [errorMessage, setErrorMessage] = useState("");
  const handleLogin = () => {
    IsAlert.fire({
      title: "Berhasil",
      text: "Registrasi akan dikirim ke email anda",
      icon: "success",
      showCancelButton: false,
      focusConfirm: true,
      confirmButtonText: "OK",
      showCancelButton: false,
    }).then(function (isConfirm) {
      if (isConfirm.isConfirmed) {
        navigate("/set-password");
      }
    });
  };
  const onSubmit = async (data) => {
    var req = await fetchApi("api/User", "POST", false, data);
    var status = req.status;
    var res = await req.json();
    if (status !== 200) {
      setErrorMessage(res.message);
    } else {
      IsAlert.fire({
        title: "Pendaftaran Berhasil",
        text: res.message,
        icon: "success",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
        showCancelButton: false,
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          navigate("/waiting-confirmation");
        }
      });
    }
  };
  return (
    <div className="bg_login row align-items-center m-0 justify-content-center">
      <form
        className="wrap_login col-lg-3 col-11 shadow p-4 bg-white rounded"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="row justify-content-center mb-4">
          <div className="logo_login col-8">
            <img
              alt=""
              className="w-100"
              src="https://connect-assets.prosple.com/cdn/ff/BxxWcDLuMPteTaLBarie733WNjM1w2h2okOUBO01EpY/1636517739/public/2021-11/banner%20for%20PUPR%20893x321.png"
            />
          </div>
        </div>
        <h1 className="mb-0">Daftar</h1>
        <p className="text-danger my-2">{errorMessage}</p>
        <div className="py-2">
          <TextField
            // color="success"
            error={errors.email ? true : false}
            helperText={errors.email ? errors.email.message : ""}
            {...register("email")}
            label="Email"
            className="w-100"
            type="text"
            variant="standard"
          />
        </div>
        <i className="text-muted">
          Note : Masukan email yang sesuai untuk melakukan verifikasi
        </i>
        <div className="py-2 mt-2">
          <Button
            type="submit"
            className="w-100"
            variant="contained"
            color="primary"
          >
            <i className="las la-user-plus mr-2"></i>
            Daftar
          </Button>
        </div>
        <p className="text-center mt-3">
          Sudah punya akun?{" "}
          <Link to="/login" className="text-success">
            Login
          </Link>{" "}
          disini
        </p>
      </form>
    </div>
  );
};
export default Daftar;
